"use client";

import VersionUpdater from "@/components/VersionUpdater";
import { AuthProvider } from "@/services/Firebase/Authcontext";

type AppClientProvidersProps = {
	children: React.ReactNode;
	sessionUser?: any;
	includeVersionUpdater?: boolean;
	enableFirebase?: boolean;
};

export default function AppClientProviders({
	children,
	sessionUser = null,
	includeVersionUpdater = true,
	enableFirebase = true,
}: AppClientProvidersProps) {
	return (
		<AuthProvider sessionUser={sessionUser} enableFirebase={enableFirebase}>
			{includeVersionUpdater ? <VersionUpdater /> : null}
			{children}
		</AuthProvider>
	);
}
